<div [innerHTML]="textString"></div>
